"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = require("../../../app-reduxs/login/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const DisplayInformationScreen = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const { phone_number, date_of_birth } = (0, react_redux_1.useSelector)((state) => state.loginReducer.userInformation);
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const getPhoneNumberFormatted = () => {
        if (!!phone_number) {
            // if (phone_number.startsWith('+81')) {
            // 	return formatPhoneNumber('0' + phone_number.substring(3))
            // }
            // return formatPhoneNumber(phone_number)
            return phone_number;
        }
        return '未登録';
    };
    (0, react_1.useEffect)(() => {
        if (connected) {
            User_1.default.getPersonalInformation()
                .then((response) => {
                dispatch((0, slice_1.updateUserInformationAction)({
                    phone_number: response.data.phone_number || '',
                    date_of_birth: response.data.date_of_birth || '',
                    change_phone_number_flag: response.data.change_phone_number_flag || null
                }));
            })
                .catch(err => {
                console.log(err);
            })
                .finally(() => {
                setLoading(false);
            });
        }
    }, [connected]);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: { flex: 1, backgroundColor: '#F7F7F7' } },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'アカウント', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
            react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(16),
                        lineHeight: (0, scale_1.moderateScale)(24),
                        color: '#292A33',
                        fontWeight: '300',
                        paddingLeft: (0, scale_1.scale)(8),
                    } }, "\u96FB\u8A71\u756A\u53F7\u30FB\u751F\u5E74\u6708\u65E5\u60C5\u5831")),
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: (0, scale_1.scale)(12),
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        color: '#545454',
                    } }, "\u96FB\u8A71\u756A\u53F7"),
                react_1.default.createElement(components_1.LinkButton, { title: "\u5909\u66F4", textStyle: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(15),
                        color: '#007AFF',
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.EDIT_PHONE_SCREEN);
                    } })),
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(15),
                    lineHeight: (0, scale_1.moderateScale)(23),
                    color: '#292A33',
                    paddingTop: (0, scale_1.scale)(8),
                } }, getPhoneNumberFormatted()),
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: (0, scale_1.scale)(12),
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        color: '#545454',
                    } }, "\u751F\u5E74\u6708\u65E5"),
                react_1.default.createElement(components_1.LinkButton, { title: "\u5909\u66F4", textStyle: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(15),
                        color: '#007AFF',
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.EDIT_BIRTHDAY_SCREEN);
                    } })),
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                    fontSize: (0, scale_1.moderateScale)(15),
                    lineHeight: (0, scale_1.moderateScale)(23),
                    color: '#292A33',
                    paddingTop: (0, scale_1.scale)(8),
                } }, date_of_birth || '未登録')),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = DisplayInformationScreen;
